export enum ApplicationRoutesEnum {
   MAIN_PAGE = 'main-page',
}

export enum FeaturesRoutesEnum {
   LINKING_FOR_FUNDING = 'linking-for-funding',
   LINKING_WITH_CLIENTS = 'linking-with-clients',
   LINKING_WITH_PNO_COLLEAGUES = 'linking-with-pno-colleagues',
   LINKING_WITH_PNO_COLLEAGUES_ID = 'linking-with-pno-colleagues/:id',
   LINKING_WITH_CLIENTS_DETAIL = 'detail',
   LINKING_WITH_CLIENTS_SEARCH = 'search',
   LINKING_FOR_FUNDING_SEARCH = 'funding-search',
}
